import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getTeamAvailibility = async (teamId, date) => {
  if (!teamId || !date) {
    return [];
  }

  const today = new Date().toISOString().split('T')[0];

  const query = supabase
    .from('teams_availability')
    .select('*')
    .eq('date', date)
    .eq('is_available', true)
    .gte('date', today);

  if (teamId !== 'random') {
    query.eq('team_id', teamId);
  }

  const { data, error } = await query;

  if (error) {
    throw new Error(error.message);
  }

  if (date === today && Array.isArray(data)) {
    const now = new Date();
    return data.filter(slot => {
      const slotDateTime = new Date(`${slot.date}T${slot.start_time}`);
      return slotDateTime >= now;
    });
  }

  return data;
};

export default function useGetAvailability(teamId, date) {
  return useQuery({
    queryKey: ['useGetAvailability', teamId, date],
    queryFn: () => getTeamAvailibility(teamId, date),
    staleTime: 0,
    enabled: !!teamId && !!date,
  });
}
